import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="py-12 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_31e6f2da-e30e-4604-a2ae-ae4870f67bdf/artifacts/m4cp44gx_passivepay_new_logo.png" 
              alt="PassivePay" 
              className="w-8 h-8 rounded-full object-cover"
            />
            <span className="font-heading font-bold">PassivePay</span>
          </Link>
          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <Link to="/paycoin" className="hover:text-primary transition-colors">PayCoin</Link>
            <Link to="/crypto-loans" className="hover:text-primary transition-colors">Crypto Loans</Link>
            <Link to="/about" className="hover:text-primary transition-colors">About</Link>
            <Link to="/contact" className="hover:text-primary transition-colors">Contact</Link>
          </div>
          <p className="text-sm text-muted-foreground">
            © 2024 PassivePay. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
